import React, { useEffect, useState } from 'react'
import Footer from '../../Components/Footer/Footer'
import Navbar from '../../Components/Navbar/Navbar'
import Cookies from 'universal-cookie'
import userApi from '../../Common/Api/UserApi'
import '../../Components/Product/Product.css'
import '../Cart/Cart.css'
import './MyOrders.css'
import { useSelector } from 'react-redux'

const MyOrders = () => {
    const cookies = new Cookies();
    const {BookWormUser} = useSelector((state)=>state)

    const {userInfo} = BookWormUser

    const [books, setBooks] = useState([{ images: ["./books/book1.jpg"], title: "Solitude Loves", price: "231", authors: ["J.K Rowling"], categories: ["Entertainment"] },{ images: ["./books/book1.jpg"], title: "Solitude Loves", price: "231", authors: ["J.K Rowling"], categories: ["Entertainment"] },{ images: ["./books/book1.jpg"], title: "Solitude Loves", price: "231", authors: ["J.K Rowling"], categories: ["Entertainment"] },{ images: ["./books/book1.jpg"], title: "Solitude Loves", price: "231", authors: ["J.K Rowling"], categories: ["Entertainment"] },{ images: ["./books/book1.jpg"], title: "Solitude Loves", price: "231", authors: ["J.K Rowling"], categories: ["Entertainment"] },{ images: ["./books/book1.jpg"], title: "Solitude Loves", price: "231", authors: ["J.K Rowling"], categories: ["Entertainment"] },{ images: ["./books/book1.jpg"], title: "Solitude Loves", price: "231", authors: ["J.K Rowling"], categories: ["Entertainment"] },]);

    const fetchOrders = async()=>{
        const res = await userApi.get('/user/orders',{
            user:{
                _id: userInfo._id
            }
        },{
            headers:{
                'Authorization': `Bearer ${cookies.get('token')}`
            }
        })

        console.log("res from fetch orders : ",res)
        setOrders(res.data.orders)
      
        console.log("orders in my orders : ",res.data.orders)
      return ()=>{}
    }

    const [orders,setOrders] = useState([]);

    const [cart,setCart] = useState([]);
    useEffect(() => {
      fetchOrders();
    }, [])
    

  return (
      <div className='Cart'>
        
      <Navbar colorRight="#5f2c3e" colorLeft="#5f2c3e" />
      <div className='cart-page'>
      <div className="CartBody">

        <div className="OrdersHeadings">
          <h4>Yours Orders</h4>
          <h4 className='order-status-h'>Status</h4>
          <h4 className='delivery-date-h'>Delivery Expected By</h4>
        </div>
        <hr />
        <div className="Products">
            {orders.map((order) => {
               
              return(
                <div className='one-order'>
                  <h6 style={{margin:"3% 0" }}>Order Id : {order._id}</h6>
                  {
              order.adId.map((Ad) => {
                
                return (
                  <div key={Ad._id}>
                    <div className="order">
                      <div className="order-details">
                         
                          <img src={Ad.images[0]} className='order-img'/>

                          <div >
                            <h4>{Ad.title}</h4>
                            <div>By - <b>{Ad.authors[0]}</b></div>
                            <div>Price - <b>{Ad.fixedPrice}</b></div>
                          </div>
                      </div>

                      <div className="order-status">
                        On-Route
                      </div>
                      <div className="delivery-date">
                        {Ad.updatedAt.substring(0,10)}
                      </div>

                    </div>
                    <hr />
                  </div>
                    )
                  })
                }
              </div>
              )
            })}
        </div>
      
      </div>
      </div>
      <Footer/>
    </div>
  )
}

export default MyOrders